import React from "react";

export const PageHeader = ({ eyebrow, title, description, actions }) => {
  return (
    <div className="px-8 pt-8 pb-6 border-b border-[var(--border)] bg-white">
      <div className="flex items-start justify-between gap-6">
        <div>
          {eyebrow && (
            <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--text-secondary)] mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[var(--text-primary)]">
            {title}
          </h1>
          {description && (
            <p className="text-sm text-[var(--text-secondary)] mt-2 max-w-2xl">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  );
};

export const Section = ({ children, className = "" }) => (
  <div className={`px-8 py-6 ${className}`}>{children}</div>
);
